import { inject, Inject, Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "./environments/environment";
import { CookieService } from 'ngx-cookie-service';
import { APP_TOKEN, AppsEnum } from '@ose/enums';

@Injectable({
  providedIn: 'root'
})
export class HttpMainService {

  headersConfig: any;
  private http = inject(HttpClient);
  private app = inject(APP_TOKEN);
  private cookieService = inject(CookieService);
  tokenPrefix = this.app == AppsEnum.SUPPORT ? 'admin-' : '';


  get<T, D = object>(url: string, params?: D): Observable<T> {
    return this.http.get<T>(`${environment.baseUrl}${url}`, {
      headers: this.headers,
      params: params as unknown as HttpParams,
    });
  }

  getText<T, D = object>(url: string, params?: D): Observable<T> {
    return this.http.get<T>(`${environment.baseUrl}${url}`, {
      params: params as unknown as HttpParams,
      responseType: 'arraybuffer' as any,
    });
  }
  post<T, D = object>(url: string, data?: D, header?: any): Observable<T> {

    let h = this.headersObj;

    if (header) {
      h = Object.assign(h, header);
    }

    return this.http.post<T>(`${environment.baseUrl}${url}`, JSON.stringify(data),
      {
        headers: h
      }
    );
  }
  patch<T, D = object>(url: string, data?: D): Observable<T> {
    return this.http.patch<T>(`${environment.baseUrl}${url}`, data,
      {
        headers: this.headers,
      }
    )
  }
  postFormData<T, D = object>(url: string, formData?: FormData, options?: any): Observable<HttpEvent<T>> {
    return this.http.post<T>(`${environment.baseUrl}${url}`, formData, {
      headers: this.formDataHeaders,
      reportProgress: true,
      observe: 'events'
    });
  }

  patchFormData<T, D = object>(url: string, formData?: FormData, options?: any): Observable<HttpEvent<T>> {
    return this.http.patch<T>(`${environment.baseUrl}${url}`, formData, {
      headers: this.formDataHeaders,
      reportProgress: true,
      observe: 'events'
    });
  }

  putFormData<T, D = object>(url: string, formData?: FormData, options?: any): Observable<HttpEvent<T>> {
    return this.http.put<T>(`${environment.baseUrl}${url}`, formData, {
      headers: this.formDataHeaders,
      reportProgress: true,
      observe: 'events'
    });
  }

  getFile(url: string, contentType?: string, params?: any): Observable<Blob> {
    return this.http.get(`${environment.baseUrl}${url}`, {
      headers: this.fileHeader(contentType),
      params: params as unknown as HttpParams,
      responseType: 'blob'
    });
  }

  put<T, D>(url: string, data?: D): Observable<T> {
    return this.http.put<T>(
      `${environment.baseUrl}${url}`,
      data,
      {
        headers: this.headers,
      }
    );
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${environment.baseUrl}${url}`, {
      headers: this.headers,
    });
  }

  get headers(): HttpHeaders {
    const accessToken = this.cookieService.get(this.tokenPrefix + 'access-token');
    const authorization = { 'Authorization': 'Bearer ' + accessToken };
    this.headersConfig = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Accept-Language': 'fa',
    };
    if (accessToken) {
      this.headersConfig = Object.assign(this.headersConfig, authorization);
    }
    return new HttpHeaders(this.headersConfig);
  }

  get headersObj() {
    const accessToken = this.cookieService.get(this.tokenPrefix + 'access-token');
    const authorization = { 'Authorization': 'Bearer ' + accessToken };
    this.headersConfig = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Accept-Language': 'fa',
    };
    if (accessToken) {
      this.headersConfig = Object.assign(this.headersConfig, authorization);
    }
    return this.headersConfig;
  }

  get formDataHeaders(): HttpHeaders {
    const accessToken = this.cookieService.get(this.tokenPrefix + 'access-token');
    const authorization = { 'Authorization': 'Bearer ' + accessToken };
    this.headersConfig = {
      'Accept-Language': 'fa'

    };
    if (accessToken) {
      this.headersConfig = Object.assign(this.headersConfig, authorization);
    }
    return new HttpHeaders(this.headersConfig);
  }

  fileHeader(contentType?: string): HttpHeaders {
    const accessToken = this.cookieService.get(this.tokenPrefix + 'access-token');
    const authorization = { 'Authorization': 'Bearer ' + accessToken };
    this.headersConfig = {
      'Accept-Language': 'fa',
    };
    if (contentType) {
      this.headersConfig = Object.assign(this.headersConfig, {
        'Content-Type': contentType,
        Accept: "text/csv",
      });
    }
    if (accessToken) {
      this.headersConfig = Object.assign(this.headersConfig, authorization);
    }
    return new HttpHeaders(this.headersConfig);
  }
}
